import config from 'config'
import { fetchWithToken } from 'utils'

export interface MeServiceResponse<T> {
  data?: T
}

const fetchMeService = async <T>(
  gqlQuery: string,
  method: 'POST' | 'GET',
): Promise<MeServiceResponse<T> | undefined> => {
  try {
    const response = await fetchWithToken({
      baseUrl: config.AUTH_SERVICE_URL,
      method: method,
      useExternalAdmin: false,
      options: {
        body: gqlQuery,
      },
      path: `me/graphql`,
      useVersion: '',
      useV5: false,
    })

    if (response.ok) {
      return response.json()
    } else {
      console.error('Response returned with not OK status', response)
    }
  } catch (err: any) {
    console.error(err.toString())
  }
}

export default fetchMeService
